import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { SideBar } from '../Common/SideBar';
import Statistics from '../../Models/Statistics';
import { Spinner } from 'reactstrap';
import {withTranslation} from "react-i18next";
class Sales extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('GLOBAL.PLEASE_LOGIN'))
            this.props.history.push('/login/seller');
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state = {
            _id: false,
            user: '',
            sales: [],
            total_sales: '',
            aff_com: '',
            vat: '',
            status: '',
            t_fee: ''
        }
        this.state.user = logged_user.id;
    };
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Statistics.getSales(this.state.user).then(res => {
            console.log(res.data)
            if (res.data.payload != null) {
                this.setState({ sales: res.data.payload })
                this.setState({ total_sales: parseInt(res.data.total_sales) })
                this.setState({ aff_com: parseInt(res.data.aff_com) })
                this.setState({ vat: parseInt(res.data.vat) })
                this.setState({ t_fee: parseInt(res.data.t_fee) })
                this.setState({ status: parseInt(res.data.status) })
            }
        })
    }

    showData() {
        if (this.state.status === 200) {
            if (this.state.sales.length == 0) {
                return (
                    <div></div>
                )
            } else {
                return (
                    <div className="">
                        {this.state.sales.map((group, i = 1) =>
                            <div className="row">
                                <div className="col-md-1">
                                    <span><b><i>{++i}</i></b></span>
                                </div>
                                <div className="col-md-11">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <span><i>{this.props.t('SELLER_SALES.TITLE')}</i></span>
                                        </div>
                                        <div className="col-md-8">
                                            <Link to={{ pathname: `/categories-details/${group.product_id}`, state: { id: group.product_id } }} className=""><span>{group.product_title}</span></Link>
                                        </div>
                                        <div className="col-md-2" style={{ fontSize: '12px' }}>
                                            <span>{(JSON.stringify(group.created_at)).substring(1, 11)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span><i style={{ marginRight: "54px" }}>{this.props.t('SELLER_SALES.SALE_PRICE')}</i></span>
                                            <span>{parseInt(group.price)}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <span><i style={{ marginRight: "88px" }}>{this.props.t('SELLER_SALES.ACTUAL_PRICE')}</i></span>
                                            <span>{parseInt(group.price) - parseInt(group.aff_commission) - parseInt(group.transaction_fee) - parseInt(group.vat_tax)}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <span><i style={{ marginRight: "40px" }}>{this.props.t('SELLER_SALES.TRAN_FEE')}</i></span>
                                            <span>{parseInt(group.transaction_fee) + parseInt(group.vat_tax)}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <span><i style={{ marginRight: "23px" }}>{this.props.t('SELLER_SALES.AFFILIATE_REWARD')}</i></span>
                                            <span>{parseInt(group.aff_commission)}</span>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '180px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font guide_text" style={{ width: '100%',fontSize:'20px' }}>
                                    {this.props.t('SELLER_SALES.SELLER_SALES_TITLE')}
                                </div>
                                {this.showData()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font guide_text" style={{ width: '100%' }}>
                                            {this.props.t('SELLER_SALES.SELLER_SALES_TITLE')}
                                    </div>
                                        {this.showData()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { Sales }
Sales = withTranslation('seller')(Sales);
